import { Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';
import { FileDownloadHelper } from '@morningstar/shared/util';

export function download(fn: (file: Blob) => Blob, fileName: string, fileType: string = 'application/octet-stream') {
  return (o$: Observable<any>): Observable<any> => {
    return o$.pipe(
      map(_ => fn(_)),
      tap(file => FileDownloadHelper.downloadFile(file, fileType, fileName))
    );
  }
}
